import { createSlice } from '@reduxjs/toolkit';
import { getDeptValue, getUserValue, isGlobalLanguage } from 'utils/common';

const myPinSlice = createSlice({
  name: 'myPin',
  initialState: {
    list: [],
    reload: 0,
    idDeleted: false,
  },
  reducers: {
    getPrioritySearchLimit: () => {},
    getPrioritySearchLimitSuccess: (state, { payload }) => {
      state.limit = payload;
    },
    getPrioritySearchList: () => {},
    getPrioritySearchListSuccess: (state, { payload }) => {
      const isGlobal = isGlobalLanguage();
      const _elements = [];
      if (payload.totalElements > 0) {
        payload.elements.forEach(item => {
          const displayInfo = `${getUserValue('fnm', item, isGlobal)} ${getDeptValue(item, isGlobal)}`;
          const _item = { ...item, displayInfo };
          _elements.push(_item);
        });
      }
      state.list = {
        ...payload,
        elements: _elements,
      };
    },
    removePrioritySearch: state => {
      state.idDeleted = false;
    },
    removePrioritySearchSuccess: state => {
      state.idDeleted = true;
      state.reload += 1;
    },
    addPrioritySearch: () => {},
    addPrioritySearchSuccess: state => {
      state.reload += 1;
    },
    reloadPage: state => {
      state.reload += 1;
    },
  },
});

export const {
  getPrioritySearchLimit,
  getPrioritySearchLimitSuccess,
  getPrioritySearchList,
  getPrioritySearchListSuccess,
  removePrioritySearch,
  removePrioritySearchSuccess,
  addPrioritySearch,
  addPrioritySearchSuccess,
  reloadPage,
} = myPinSlice.actions;
export default myPinSlice.reducer;
